// extracted by mini-css-extract-plugin
export default {"deleteOrdeTable":"DeleteOrderTable_deleteOrdeTable__CnuRD"};